module.exports = __webpack_public_path__ + "img/icon-team-type-4.66574067.png";